var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.typeComponent == 'Single')?_c('img',{class:_vm.classes,style:(_vm.styles),attrs:{"src":_vm.srcComponent,"height":_vm.height},on:{"error":_vm.loadPlaceholder}}):_c('v-img',{class:_vm.classes,style:(_vm.styles),attrs:{"src":_vm.srcComponent,"height":_vm.height},on:{"error":_vm.loadPlaceholder}})
}
var staticRenderFns = []

export { render, staticRenderFns }